import script from "./investDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./investDetail.vue?vue&type=script&lang=ts&setup=true"

import "./investDetail.vue?vue&type=style&index=0&id=76c7784e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c7784e"]])

export default __exports__